import React from "react";
import { styled } from "../stitches.config";
import { observer, inject } from "mobx-react";
import Formsy from "formsy-react";

import Input from "./Input";

@inject("UIStore")
@observer
export default class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      canSubmit: false,
      status: "Podziel się z nami swoim pomysłem"
    };
  }

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  submit = model => {
    fetch(window.API_HOST + "/trudat-ideas/", {
      method: "POST",
      // headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(model)
    })
      .then(() => {
        this.setState({ status: "Wysłano!" });
        setTimeout(
          () => this.props.UIStore.togglePopUpVisibility("modal"),
          2000
        );
      })
      .catch(() => {
        this.setState({
          status: "Wystąpił problem z siecią, spróbuj ponownie później"
        });
      });
  };

  notifyFormError = (data, resetForm, invalidateForm) => {
    let errs = {};
    this.refs.form.inputs.forEach(input => {
      if (input.showRequired()) {
        errs[input.props.name] =
          input.props.validationError === ""
            ? input.props.validationErrors["isDefaultRequiredValue"]
            : input.props.validationError;
      }
    });
    invalidateForm(errs);
  };

  render() {
    return (
      <ModalWrapper>
        <ContentWrap>
          <Header>
            <h3> {this.state.status} </h3>
          </Header>
          <Formsy
            ref="form"
            onValidSubmit={this.submit}
            onInvalidSubmit={this.notifyFormError}
            onValid={this.enableButton}
            onInvalid={this.disableButton}
          >
            <Body>
              <div>
                <label>
                  <Input
                    type="text"
                    name="name"
                    placeholder="Imię i nazwisko"
                    validationError="Pole wymagane"
                    required
                  />
                </label>
                <label>
                  <Input
                    type="email"
                    name="email"
                    placeholder="Email"
                    validationError="Pole wymagane"
                    required
                  />
                </label>
                <label>
                  <Input
                    type="text"
                    name="topic"
                    placeholder="Temat trudata"
                    validationError="Pole wymagane"
                    required
                  />
                </label>
                <label>
                  <Input
                    type="textarea"
                    name="description"
                    placeholder="Krótki opis.."
                    validationError="Pole wymagane"
                    required
                  />
                </label>
              </div>
            </Body>
            <CloseModal
              type="button"
              onClick={() => this.props.UIStore.togglePopUpVisibility("modal")}
            >
              {" "}
              Zamknij{" "}
            </CloseModal>
            <input type="submit" />
          </Formsy>
        </ContentWrap>
      </ModalWrapper>
    );
  }
}

const ModalWrapper = styled("div",{
  position: "fixed",
  color: "#333",
  top: "0",
  left: "0",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "rgba(10, 10, 10, 0.7)",
  width: "100vw",
  height: "100vh",
  zIndex: 1050
});

const ContentWrap = styled("div", {
  textAlign: "center",
  background: "#fff",
  transition: "all 3s ease-in-out",
  maxWidth: "700px",
  borderRadius: "0",
  position: "relative",
  "h3": {
    margin: "0px",
    fontSize: "22px"
  },
  "h2": {
    opacity: 0,
    transition: "all 0.3s ease-in-out",
    textAlign: "center",
    color: "#333"
  },
  "label": {
    maxWidth: "400px",
    width: "100%",
    display: "inline-block"
  },
  "input,  textarea": {
    margin: "10px",
    border: "2px solid #909090",
    padding: "5px",
    borderRadius: "0",
    fontSize: "15px",
    width: "100%",
    color: "rgb(144, 144, 144)",
    outline: "0",
    fontWeight: "bold"
  },
  "textarea": {
    height: "100px"
  },
  'input[type="submit"]': {
    textTransform: "uppercase",
    letterSpacing: "1px",
    color: "#fff",
    fontWeight: "bold",
    background: "#3b17d5",
    width: "165px",
    margin: "0px 10px 20px 0px",
    border: "0px",
    borderRadius: "0",
    display: "inline-block",
    marginRight: "auto"
  }
});

const Header = styled("div", {
  margin: "0",
  background: "#3b17d5",
  color: "#fff",
  padding: "15px",
  textAlign: "center",
  position: "relative"
});

const CloseModal = styled("button", {
  textTransform: "uppercase",
  letterSpacing: "1px",
  fontSize: "15px",
  color: "#fff",
  fontWeight: "bold",
  background: "#3b17d5",
  width: "165px",
  textAlign: "center",
  margin: "0px 10px 20px 0px",
  borderRadius: "0",
  border: "0px",
  cursor: "pointer",
  display: "inline-block",
  padding: "5px"
});

const Body = styled("div", {
  padding: "40px 30px 10px 30px",
  textAlign: "center"
});
